import "primeicons/primeicons.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
// import ReactDOM from "react-dom";

import React, { useState, useEffect } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

// import { Carousel } from "primereact/carousel";
// import { Button } from "primereact/button";
// import { useDispatch, useSelector } from "react-redux";

import "src/Assets/css/home/CarouselDemo.css";
// import styles from "src/Assets/css/home/post.module.css";
// import feedstyles from "src/Assets/css/home/feedpost.module.css";
// import Avatar from "@material-ui/core/Avatar";
import AvatarBadge from "src/Components/AvatarBadge";

const settings = {
  // className: "center",
  // centerMode: true,
  // infinite: true,
  // centerPadding: "60px",
  slidesToShow: 1,
  // speed: 500,
  rows: 2,
  slidesPerRow: 3,
};

const Contributors = (props) => {
  const { contributorsData, handleClickEvent } = props;
  const src = process.env.REACT_APP_SKOPIC_IMAGE;
  const [products, setProducts] = useState([]);
  const [sliderSettings, setSliderSettings] = useState({ ...settings });

  useEffect(() => {
    const handleResize = () => {
      const windowWidth = window.innerWidth;
      let slidesPerRow = 3;
      if (windowWidth < 768) {
        slidesPerRow = 6;
      }
      if (windowWidth >= 768 && windowWidth <= 991) {
        slidesPerRow = 10;
      }
      setSliderSettings({ ...settings, slidesPerRow });
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    // productService.getProductsSmall().then(data => setProducts(data.slice(0, 6)));
    if (contributorsData) {
      if (contributorsData && Object.keys(contributorsData).length !== 0) {
        if (contributorsData.contribut) {
          setProducts(contributorsData.contribut);
          // setContributors(contributorsData.contribut.slice(7,10))
          // console.log("hi im" + contributorsData);
        }
      }
    }
  }, [contributorsData]);

  return (
    <div style={{ position: "relative" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          position: "absolute",
          top: "8px",
          left: "20px",
          zIndex: 1,
        }}
      >
        <div
          style={{
            marginRight: "4px",
            fontSize: "14px",
            fontWeight: "700",
            color: "#373334",
          }}
        >
          Contributors
        </div>
        <IoIosCheckmarkCircleOutline fontSize={16} />
      </div>
      <Slider
        {...sliderSettings}
        style={
          props?.pageType === "homePage" ? { backgroundColor: "#efeeed" } : {}
        }
        className={`slick-slider ${props?.pageType === "homePage" ? "homePageStyle" : ""}`}
      >
        {products && Object.keys(products).length !== 0 ? (
          products.map((product, i) => (
            <div className="carousel-demo" key={`key-${product?.id}`}>
              {/* <div className="card"> */}
              <div className="product-item">
                <div className="product-item-content">
                  <div
                    style={{ display: "inline-block", cursor: "pointer" }}
                    onMouseEnter={(e) =>
                      handleClickEvent(product.id, true, e.currentTarget)
                    }
                    onMouseLeave={() => handleClickEvent(0, false, null)}
                  >
                    <AvatarBadge
                      src={
                        product.uImage
                          ? `${src}${product.uImage}`
                          : process.env.REACT_APP_DUMMY_PROFILE_IMAGE
                      }
                      alt={product.displayName}
                      isPrimaryModerator={Number(product.isPM) === 1}
                      isModerator={Number(product.isModerator) === 1 && Number(product.isPM) === 0}
                      size={50}
                      className="product-image"
                    />
                  </div>
                  {/* <div className="hover-Box">
                    <div style={{display:"flex"}}>
                    <p >
                       SAY {product.say} | UPDATE{" "}
                      {product.iUpdate} | Bio {product.shortBio}
                    </p>
                    </div>
                  </div> */}
                </div>
              </div>
              {/* </div> */}
            </div>
          ))
        ) : (
          <p>No Data</p>
        )}
      </Slider>
    </div>
  );
};

export default Contributors;
